import { createBrowserRouter } from 'react-router';
import { MarketingSurface } from './r6/MarketingSurface';
import { ShowcaseSurface } from './r6/ShowcaseSurface';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { AboutPage } from './pages/AboutPage';
import { CrdShowcasePage } from './pages/CrdShowcasePage';
import { DesignerPage } from './pages/DesignerPage';

export const router = createBrowserRouter([
  {
    element: <MarketingSurface />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'about', element: <AboutPage /> },
    ],
  },
  {
    path: 'crd',
    element: <ShowcaseSurface />,
    children: [
      { index: true, element: <CrdShowcasePage /> },
    ],
  },
  {
    path: 'designer',
    element: <DesignerPage />,
  },
]);
